import { Component, OnInit } from '@angular/core';
import { ReviewSurveyService } from 'src/app/services/review-survey/review-survey.service';
import { Observable, Subscription, map } from 'rxjs';
import { Page } from 'src/app/models/data/page.model';
import { Router } from '@angular/router';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';
import { CompletionQuestionsService } from 'src/app/services/completion-questions/completion-questions.service';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css'],
  imports: [CommonModule, NgxPaginationModule],
})
export class ReviewComponent implements OnInit {
  p: number = 1;
  pages$!: Observable<Page[]>;
  headers = ['Section', 'Status', 'Link'];
  reviewSub!: Subscription;
  message = 'If you think you are done, please hit the submit button below';
  completed = false;

  constructor(
    private reviewService: ReviewSurveyService,
    private router: Router,
    private dropdownService: DropdownService,
    private completionQuestionsService: CompletionQuestionsService,
  ) { }

  ngOnInit(): void {
    this.reviewService.getSurveyReview();
    // Filter out Page 29 (Submit Survey) from the invalid pages list
    this.pages$ = this.reviewService.getPageStatusObs().pipe(
      map(pages => pages.filter(page => page.PageNumber !== 29))
    );
    this.updateView();

    this.pages$.subscribe((pages) => {
      pages.forEach((page) => {
        console.log('Page Title:', page.Title);
      });
    });
  }

  onNavigate(page: Page) {
    // Use the route from the database
    const route = page.Route.startsWith('/') ? page.Route : `/${page.Route}`;
    this.router.navigate([route]);
  }

  submitSurvey() {
    // First, answer Question 46 to make Page 29 valid
    this.completionQuestionsService.updateCompletionQuestion(46, true).subscribe({
      next: (completionRes) => {
        console.log('Question 46 answered successfully:', completionRes);

        // Now that Page 29 is valid, call the Complete endpoint
        this.reviewService.completeSurvey().subscribe({
          next: (res) => {
            console.log('Survey completion successful:', res);
            this.dropdownService.setPageCompletionStatuses();
            this.updateView();
          },
          error: (error) => {
            console.error('Survey completion failed:', error);
            alert('Failed to submit survey. Please try again or contact support if the problem persists.');
          }
        });
      },
      error: (completionError) => {
        console.error('Failed to answer Question 46:', completionError);
        alert('Failed to prepare survey for submission. Please try again.');
      }
    });
  }

  updateView() {
    this.reviewService.checkCompleted().subscribe((res) => {
      if (res.completed == true) {
        this.completed = true;
      } else {
        this.completed = false;
      }
    });
  }
}
